import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { getSubdomainHelper } from 'src/helpers/getSubdomainHelper';
import { ZENDESK_HELP_CENTER_URL } from 'src/constants/urls';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

// The Zendesk API subdomain and brand, needed for private or synced help centers.
export const ZendeskHelpCenterBrandFields = ({
  control,
}: {
  control: Control<ZendeskHelpCenterFormValues>;
}) => (
  <>
    <Controller
      control={control}
      name="zendesk_subdomain"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Input
          type={'text'}
          label={'Zendesk API Subdomain'}
          placeholder={'brand'}
          invalidMessage={error?.message}
          value={value}
          isValid={!error?.message}
          onChange={(e) => {
            const res = getSubdomainHelper(e.target.value);
            if (res?.subdomain) {
              onChange(res?.subdomain);
            } else {
              onChange(e.target.value);
            }
          }}
          infoTooltip={{
            side: 'right',
            description: (
              <>
                <a
                  href={ZENDESK_HELP_CENTER_URL.API_SUBDOMAIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline cursor-pointer"
                >
                  Here
                </a>{' '}
                is where to find it
              </>
            ),
          }}
        />
      )}
    />
    <Controller
      control={control}
      name="brand_id"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Input
          type={'text'}
          label={'Zendesk Brand ID'}
          placeholder={'-------------------'}
          invalidMessage={error?.message}
          value={value}
          isValid={!error?.message}
          onChange={onChange}
          infoTooltip={{
            side: 'right',
            description: (
              <>
                Check how to find your Brand ID{' '}
                <a
                  href={ZENDESK_HELP_CENTER_URL.BRAND_ID}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline cursor-pointer"
                >
                  here →
                </a>
              </>
            ),
          }}
        />
      )}
    />
  </>
);
